<template>
  <div>
    <Create
      :createDialog="createDialog"
      @close="createDialog = false"
      @submit="getList"
    ></Create>    
    <v-autocomplete
      :items="Donors" 
      outlined 
      @change="$emit('change', selectedDonor)"
      :error-messages="errorMessages"
      rounded
      :hide-details="errorMessages.length === 0 ? true : false"
      prepend-inner-icon="search"
      dense
      :loading="loading" 
      auto-select-first
      label="Select Donor"
      single-line
      :search-input.sync="customerInput"
      clearable
      item-text="name"
      return-object
      v-model="selectedDonor"
    >
      <template slot="item" slot-scope="{ item }">
        <span>{{ item.name }}</span>
        <v-spacer></v-spacer>
        <span>{{ item.balance | currency }}</span>
      </template>
      <template v-slot:append-item>
        <v-divider class="mb-2"></v-divider>
        <v-list-item @click="createDialog = true">
          <v-list-item-content>
            <v-list-item-title>Create New Donor</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import donorService from "@/modules/Donors/service.js";
const Create = () => import("@/modules/Donors/components/Create.vue");

export default {
  props: {
    errorMessages: {
      default: function() {
        return [];
      }
    },
    initValue: {
      default: null
    }
  },
  data() {
    return {
      createDialog: false,
      customerInput: null,
      Donors: [],
      loading: false,
      selectedDonor: null
    };
  },
  components: {
    Create
  },
  watch: {
    selectedDonor(val) {
      if (val) {
        this.$emit("input", val);
        this.$emit("reset");
      }
    },
    initValue(val) {
      this.selectedDonor = val
    }
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      return donorService.getAll().then(response => {
        this.loading = false;
        this.Donors = response.data;
        // console.log('this.Donors', this.Donors)
        // if (this.$route.query && this.$route.query.CustomerId) {
        //   const _donorId = this.initValue 
        //   const result = this.Donors.find(({ id }) => id == _donorId);
        //   this.selectedDonor = result
        // }
      });
    }
  }
};
</script>

<style scoped></style>
